module.exports = __webpack_public_path__ + "media/img/super-venue/icons/badge-d73890ded051e658ead992db85556143.svg";